import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { ConditionGroupExpressionSchema } from '../../../../expressions/repository/condition-group/ConditionGroupExpressionSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type IComputedBooleanWidget } from '../IComputedWidget.ts';

export const computedBooleanConfigSchema: yup.ObjectSchema<IComputedBooleanWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup
      .string()
      .required()
      .exact(WidgetType.ComputedBoolean)
      .label('Tipo'),
    expression: ConditionGroupExpressionSchema.required().label('Espressione'),
    text: RichTextAdvancedSchema.optional().label('Testo'),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
    }),
  });
